import { useCallback } from 'react';
import { DEMO_EXIT_CONFIRMATION_COMPONENT, demoExitConfirmationComponentDef } from 'navigation-components/config';
import { useComponentProps, useToggleComponent } from 'navigation-components/platform/hooks';
import convertToAbsolutePath from '../utils/convertToAbsolutePath';
import useShouldShowDemoExitConfirmationComponent from './useShouldShowDemoExitConfirmationComponent';
const useDemoExitConfirmationComponent = () => {
  const {
    shouldShowDemoExitConfirmationComponent
  } = useShouldShowDemoExitConfirmationComponent();
  const demoExitConfirmationComponentProps = useComponentProps(demoExitConfirmationComponentDef);
  const {
    toggle: toggleDemoExitConfirmationComponent
  } = useToggleComponent(DEMO_EXIT_CONFIRMATION_COMPONENT);
  const onNavLinkClick = useCallback((event, path) => {
    if (shouldShowDemoExitConfirmationComponent) {
      event.preventDefault();
      toggleDemoExitConfirmationComponent();
      demoExitConfirmationComponentProps({
        url: convertToAbsolutePath(path),
        appSource: 'onboarding-demo'
      });
    }
  }, [shouldShowDemoExitConfirmationComponent, toggleDemoExitConfirmationComponent, demoExitConfirmationComponentProps]);
  return {
    onNavLinkClick
  };
};
export default useDemoExitConfirmationComponent;